<vb-lxp-root [headerConfig]="headerConfig" [footerConfig]="footerConfig"></vb-lxp-root>